<form [formGroup]="form" class="flex flex-col gap-4">
  <div class="flex flex-col gap-2">
    <label for="name" class="text-sm font-medium text-gray-700">Name *</label>
    <input
      pInputText
      id="name"
      formControlName="name"
      [fluid]="true"
      placeholder="Enter name for the custom instruction"
      class="w-full" />
    <small *ngIf="error()" class="text-red-500">{{ error() }}</small>
  </div>

  <div class="flex justify-end gap-2 mt-6">
    <p-button
      label="Cancel"
      severity="secondary"
      [outlined]="true"
      [disabled]="isLoading()"
      (click)="onCancel()"></p-button>
    <p-button
      label="Save"
      icon="pi pi-save"
      [loading]="isLoading()"
      [disabled]="!form.valid || isLoading()"
      (click)="onSave()"></p-button>
  </div>
</form>
